<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="InvoicesDetailsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('invoice.deposit_processing')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-success">{{translations('invoice.message_information')}}</div>
          <div class='form-inline mb-4'>
            <div class="form-group">
              <div class="mr-2">{{translations('invoice.payment_day')}}</div>
              <input type='date' v-model="paymentAt" class='form-control'>
            </div>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('invoice.customer_name')}}</th>
                <th>{{translations('invoice.billing_amount')}}</th>
                <th>{{translations('invoice.deposit_amount')}}</th>
                <th>{{translations('invoice.adjustment_amount')}}</th>
                <th>{{translations('invoice.transfer_fee')}}</th>
                <th>{{translations('invoice.remaining_amount')}}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td>{{client}}</td>
                <td class="right">{{Number(balance).toLocaleString()}}</td>
                <td>
                  <input v-model="paid" type="text" class="form-control" :disabled="isFinish">
                </td>
                <td>
                  <input v-model="adjustment" type="text" class="form-control" :disabled="isFinish">
                </td>
                <td>
                  <input v-model="transferFee" type="text" class="form-control" :disabled="isFinish">
                </td>
                <td class="right">{{Number(remainingPrice).toLocaleString()}}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <input id="is_finish" type="checkbox" class="btn btn-primary" v-model="isFinish">
          <label for="is_finish">{{translations('invoice.notification')}}</label>
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="addPayment()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'InvoicesDetailsModal',
  components: {
    VueElementLoading
  },
  props: {
    billingID: Number,
    client: String
  },
  data: function () {
    return {
      paymentAt: '',
      paid: 0,
      balance: 0,
      transferFee: 0,
      adjustment: 0,
      remainingPrice: 0,
      isFinish: false,
      isSearching: false,
      totalAmount: 0,
      totalPaid: 0
    }
  },
  watch: {
    paid: {
      handler: function (data, oldData) {
        if (isNaN(Number(data))) {
          this.paid = oldData
        } else {
          this.calcRemainingPrice()
        }
      }
    },
    adjustment: {
      handler: function (data, oldData) {
        this.calcRemainingPrice()
      }
    },
    transferFee: {
      handler: function (data, oldData) {
        this.calcRemainingPrice()
      }
    },
    balance: {
      handler: function (data, oldData) {
        this.calcRemainingPrice()
      }
    }
  },
  mounted: function () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.getBilledPayments)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    calcRemainingPrice: function () {
      this.remainingPrice = Number(this.balance) - (Number(this.paid) + Number(this.transferFee) + Number(this.adjustment)) - Number(this.totalPaid)
    },

    async getBilledPayments () {
      try {
        this.isSearching = true
        let params = {
          billing_id: this.billingID
        }

        await this.$http.post(this.$api_url.billed_payment_list, params).then(billing => {
          if (billing.data) {
            if (billing.data.status === true) {
              this.transferFee = billing.data.transfer_fee
            } else {
              this.transferFee = 0
            }

            this.balance = billing.data.balance
            this.paymentAt = billing.data.payment_schedule_at
            this.totalAmount = billing.data.total_amount_inctax
            this.totalPaid = billing.data.total_paid
          }

          this.isSearching = false
        })
      } catch (error) {
        this.isSearching = false
        console.log('ArchivePayments:API:getBilledPayments:error: ', error)
      }
    },

    addPayment: function () {
      if (this.paymentAt.replace('/', '') === '') {
        this.$toastr.warning(this.translations('invoice.notice_enter_payment_date'))
        return
      }
      if (isNaN(Number(this.paid))) {
        this.$toastr.warning(this.translations('invoice.notice_enter_amount_half_width_numbers'))
        return
      }
      if (isNaN(Number(this.adjustment))) {
        this.$toastr.warning(this.translations('invoice.notice_enter_adjustment_amount_half_width_numbers'))
        return
      }
      if (isNaN(Number(this.transferFee))) {
        this.$toastr.warning(this.translations('invoice.notice_enter_bank_transfer_half_width_numbers'))
        return
      }

      this.$dialog.confirm(this.translations('invoice.notice_proceed_deposit'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        this.isSearching = true
        try {
          let paramUpdate = {
            billing_id: this.billingID, // 代表ID
            paid_at: this.paymentAt,
            transfer_fee: this.transferFee,
            adjustment: this.adjustment,
            paid: this.paid,
            is_finish: this.isFinish ? 1 : 0
          }
          const response = await this.$http.post(this.$api_url.billing_add_payment, paramUpdate)
          const result = response.data
          console.log('SingleInvoices:addPayment: ', result)
          if (result.status === true) {
            this.$toastr.success(this.translations('invoice.notice_proceed_deposit_success'), this.translations('common.success'))
            this.$parent.billingInfo.billing_status = result.billing_status // (1=入金待ち,2=入金済,3=未請求)
            this.$refs.closeModal.click()
            setTimeout(() => {
              this.$emit('paid')
            }, 100)
          } else {
            this.$toastr.error(result.message, this.translations('common.error'))
          }
          this.isSearching = false
        } catch (error) {
          console.log('SingleInvoices:addPayment:catch(error): ', error)
          this.$toastr.error(this.translations('invoice.notice_failed'), this.translations('common.error'))
        }
      })
    }
  }
}
</script>
